export default __webpack_public_path__ + "static/media/NovoClientPanel.7469970c.svg";